module.exports = __webpack_public_path__ + "static/into-icon.02f5dc91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/into-icon.svg
// module id = 543
// module chunks = 1